import * as React from 'react';

import {HelpButton} from 'shells/help/help-button';
import {ChevronDownIcon, ChevronRightIcon} from 'shells/icon';
import {NewBadge} from 'shells/new-badge/new-badge';

import styles from './sales-process-info-bar.module.css';

type Props = {
    isExpanded: boolean;
    onToggleExpand: () => any;
    titleText: string;
    subtitleText: string;
    isCollapsible: boolean;
    helpComponent: React.ComponentType<any> | null | undefined;
    // For a component not controlled by local state, such as an OpenableModal
    uncontrolledHelpComponent?: React.ComponentType<any>;
    isNew?: boolean;
};

type State = {
    isShowingHelp: boolean;
};

/*
 * Component responsible for rendering the long skinny bar of helper text
 * at the top of each sales process section (step templates, automations, overlays).
 *
 * This is only rendered by the first column, as it spans the entire row.
 */
export class SalesProcessInfoBar extends React.PureComponent<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isShowingHelp: false,
        };
    }

    render() {
        const getHelpComponent = () => {
            const UncontrolledComponent = this.props.uncontrolledHelpComponent;
            if (UncontrolledComponent) {
                return <UncontrolledComponent />;
            } else if (this.props.helpComponent) {
                // @ts-expect-error
                return <HelpButton onClick={this.showHelp} />;
            } else {
                return null;
            }
        };

        const Help = this.props.helpComponent;

        return (
            <div
                className={
                    this.props.isCollapsible
                        ? styles['help-container--collapsible']
                        : styles['help-container']
                }
            >
                {this.props.isCollapsible ? (
                    <button
                        type='button'
                        onClick={this.props.onToggleExpand}
                        className={styles.icon}
                    >
                        {this.props.isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
                    </button>
                ) : undefined}
                {this.props.isNew ? (
                    <div className='pr-8'>
                        <NewBadge />
                    </div>
                ) : null}
                <span onClick={this.props.onToggleExpand} className={styles['help-header']}>
                    {this.props.titleText}
                </span>
                <span className={styles['help-subtitle']}>{this.props.subtitleText}</span>
                {getHelpComponent()}
                {Help ? <Help isOpen={this.state.isShowingHelp} onClose={this.closeHelp} /> : null}
            </div>
        );
    }

    showHelp = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({isShowingHelp: true});
    };

    closeHelp = () => {
        this.setState({isShowingHelp: false});
    };
}
